"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zodToJsonSchema = void 0;
const zodToJsonSchema_1 = require("./src/zodToJsonSchema");
Object.defineProperty(exports, "zodToJsonSchema", { enumerable: true, get: function () { return zodToJsonSchema_1.zodToJsonSchema; } });
exports.default = zodToJsonSchema_1.zodToJsonSchema;
